<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="back">
      </div>
      <div class="header-card-text">
        <h3>Save Funds</h3>
      <!--<p class="sub-text fnt-14">Use the options below to fund your Smart Stewards wallet</p>-->
      </div>
    </div>
    <div class="inv-header-tabs d-flex justify-content-between">
      <div class="text-center w-50" :class="[plansTab ? 'active' : '']" @click="toggle('plans')">
        <h4>Plans</h4>
      </div>
      <div class="text-center w-50" :class="[myTab ? 'active' : '']" @click="toggle('my')">
        <h4>My Savings</h4>
      </div>
    </div>

    <div v-if="plansTab" class="content">
      <div v-if="plansLoading" class="text-center mt-4">
        <vue-loaders-ball-beat color="#EE0E4C" scale="0.8" />
      </div>
      <template v-else>
        <div
          v-for="(plan) in plans"
          :key="plan.id"
          @click="openSavings(plan.id)"
          class="savings-card"
        >
          <div class="card-header">
            <div class="plan-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
            </div>
            <div class="plan-info">
              <h3>{{ plan.name }}</h3>
              <div class="interest-rate">{{ plan.percentage }}% p/a</div>
            </div>
          </div>
          <div class="card-body">
            <p class="plan-description">
              {{ plan.description }}
              <span class="warning-text">Interest will be forfeited if you break your investment before maturity.</span>
            </p>
            <div class="plan-features">
              <div class="feature">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ plan.duration }} month{{ plan.duration !== 1 ? 's' : '' }} lock period</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- ── My Savings tab ───────────────────────────────────────────── -->
    <div v-if="myTab" class="my-savings-panel">

      <div class="savings-summary d-flex justify-content-between">
        <div class="summary-card">
          <p class="label">Total Locked</p>
          <p class="value">₦ {{ fmt(totalLocked) }}</p>
        </div>
        <div class="summary-card">
          <p class="label">Total Interest</p>
          <p class="value">₦ {{ fmt(totalInterest) }}</p>
        </div>
        <div class="summary-card">
          <p class="label">Active Locks</p>
          <p class="value">{{ mySavings.length }}</p>
        </div>
      </div>

      <div v-if="savingsLoading" class="text-center mt-4">
        <vue-loaders-ball-beat color="#EE0E4C" scale="0.8" />
      </div>
      <div v-else-if="mySavings.length === 0" class="empty-trans">
        <p>You have no locked savings yet.</p>
        <button class="browse-btn" @click="toggle('plans')">Browse Plans</button>
      </div>
      <div v-else class="trans-table">
        <div class="trans-table-row savings-row" v-for="(s, i) in mySavings" :key="i">
          <div class="savings-row-top">
            <p class="plan-name">{{ s.savingPlan ? s.savingPlan.name : 'Savings Plan' }}</p>
            <div class="process-label" v-if="!isMatured(s.maturity_date)">Locked</div>
            <div class="success-label" v-else>Matured</div>
          </div>
          <div class="savings-row-detail">
            <div>
              <p class="detail-label">Locked</p>
              <p>₦ {{ fmt(s.amount) }}</p>
            </div>
            <div>
              <p class="detail-label">Interest</p>
              <p>₦ {{ fmt(s.savings_interest) }}</p>
            </div>
            <div>
              <p class="detail-label">Matures</p>
              <p>{{ s.maturity_date | formatDate2 }}</p>
            </div>
          </div>
          <div class="savings-row-actions">
            <span v-if="pendingRequests[s.id]" class="pending-badge">Withdrawal Requested</span>
            <button
              v-else
              class="withdraw-btn"
              @click="confirmWithdraw(s)"
              :disabled="withdrawing === s.id"
            >
              {{ withdrawing === s.id ? 'Submitting…' : 'Request Withdrawal' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Premature withdrawal confirmation modal -->
      <div v-if="showConfirm" class="modal-overlay" @click.self="showConfirm = false">
        <div class="confirm-modal">
          <h4>Request Early Withdrawal?</h4>
          <p>You are requesting early withdrawal of <strong>₦ {{ fmt(confirmSavings && confirmSavings.amount) }}</strong> from <strong>{{ confirmSavings && confirmSavings.savingPlan ? confirmSavings.savingPlan.name : 'your savings' }}</strong>.</p>
          <p class="warning-text">⚠ All accrued interest will be forfeited. You will only receive your principal amount.</p>
          <div class="modal-actions">
            <button class="cancel-btn" @click="showConfirm = false">Cancel</button>
            <button class="confirm-btn" @click="submitWithdraw" :disabled="withdrawing === (confirmSavings && confirmSavings.id)">Confirm Request</button>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { withWalletTypeParams } from '@/utils/walletType';

export default {
  data() {
    return {
      // tab state
      plansTab: true,
      myTab: false,
      // plans state (dynamic from API)
      plans: [],
      plansLoading: false,
      // my savings state
      mySavings: [],
      totalLocked: 0,
      totalInterest: 0,
      savingsLoading: false,
      // withdrawal request state
      pendingRequests: {},
      withdrawing: null,
      showConfirm: false,
      confirmSavings: null,
    };
  },
  created() {
    this.fetchPlans();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    openSavings(plan) {
      this.$router.push(`/savings/${plan}/plan`);
    },
    async fetchPlans() {
      this.plansLoading = true;
      try {
        const params = withWalletTypeParams(this.$store);
        const res = await this.$http({ url: `${this.$baseUrl}/savings-plans`, method: 'GET', params });
        this.plans = res.data.plans;
      } catch (e) {
        this.$toasted.error('Could not load savings plans.');
      } finally {
        this.plansLoading = false;
      }
    },
    toggle(tab) {
      if (tab === 'plans') {
        this.plansTab = true;
        this.myTab = false;
      } else {
        this.plansTab = false;
        this.myTab = true;
        if (this.mySavings.length === 0) this.getMySavings();
      }
    },
    async getMySavings() {
      this.savingsLoading = true;
      try {
        const params = withWalletTypeParams(this.$store);
        const res = await this.$http({ url: `${this.$baseUrl}/savings`, method: 'GET', params });
        this.mySavings = res.data.savings;
        this.totalLocked = res.data.totalLocked;
        this.totalInterest = res.data.totalInterest;
        await this.fetchPendingRequests();
      } catch (e) {
        this.$toasted.error('Could not load your savings. Please try again.');
      } finally {
        this.savingsLoading = false;
      }
    },
    async fetchPendingRequests() {
      try {
        const res = await this.$http({ url: `${this.$baseUrl}/withdrawal-requests`, method: 'GET' });
        const pending = {};
        (res.data.transactions || []).forEach((r) => {
          if (r.request_type === 'savings' && r.savings_id && r.status === 'requested') {
            pending[r.savings_id] = true;
          }
        });
        this.pendingRequests = pending;
      } catch (e) {
        // non-critical, ignore
      }
    },
    confirmWithdraw(savings) {
      this.confirmSavings = savings;
      this.showConfirm = true;
    },
    async submitWithdraw() {
      const s = this.confirmSavings;
      if (!s) return;
      this.withdrawing = s.id;
      this.showConfirm = false;
      try {
        await this.$http({
          url: `${this.$baseUrl}/savings/${s.id}/request-premature-withdrawal`,
          method: 'POST',
        });
        this.$toasted.success('Withdrawal request submitted. Our team will process it shortly.');
        this.$set(this.pendingRequests, s.id, true);
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message
          ? e.response.data.message
          : 'Could not submit withdrawal request. Please try again.';
        this.$toasted.error(msg);
      } finally {
        this.withdrawing = null;
        this.confirmSavings = null;
      }
    },
    isMatured(date) {
      return new Date(date) <= new Date();
    },
    fmt(n) {
      // eslint-disable-next-line max-len
      return Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
};
</script>

<style lang="scss" scoped>
  a{
    color: #EE0E4C;
    font-weight: 400;
  }
  p {
    margin-bottom: .25rem;
  }
  .account_balance{
    margin: 0 0 1rem 0;
    background-color: #EE0E4C;
    color: #FFF;
    padding: 1rem;
    text-align: center;
    font-size: 20px;
    line-height: 1.5;
    border-radius: 8px;
  }
  .trans-table{
    padding: 1rem;
    border-radius: 8px;
    background-color: #FFF;
    &-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .75rem 0;
      border-bottom: 1px solid #E5E5E5;
      &:last-child{
        border-bottom: none;
      }
    }
    .row1{
      .p1{
        font-size: 11px;
        line-height: 12px;
        color: #49566A;
        font-family: 'Cabin', sans-serif;
      }
    }
    .row2{
      p{
        font-family: 'Cabin', sans-serif;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
  .transactions{
    margin-top: 1rem;
  }
  form{
    margin-bottom: 2rem;
  }
  .notification{
    text-align: center;
    font-family: 'Cabin', sans-serif;
    font-weight: 600;
    font-size: 16px;
    // margin-top: 2rem;
    p{
      margin-bottom: 1rem;
    }
  }
  .loadingText{
    font-size: 20px;
  }
  .success-label{
    background-color: rgba($color: #50A948, $alpha: 0.2);
    color: #50A948;
    padding: .25rem;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
  }
  .process-label{
    background-color: #FFDDE6;
    color: #EE0E4C;
    padding: .25rem;
    border-radius: 8px;
    font-weight: 400;
    font-size: 11px;
    text-align: center;
  }
  .empty-trans{
    margin-top: 2rem;
    text-align: center;
    color: #6b6b6b;
  }
  .content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .savings-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    padding: 1.5rem;
    box-shadow: 0 4px 20px rgba(238, 14, 76, 0.1);
    border: 1px solid rgba(238, 14, 76, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 30px rgba(238, 14, 76, 0.2);
      border-color: rgba(238, 14, 76, 0.3);
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #EE0E4C 0%, #FF6B9D 100%);
    }
  }

  .card-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .plan-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    flex-shrink: 0;
  }

  .plan-info {
    flex: 1;
  }

  .plan-info h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #2d3748;
    font-family: 'Open Sans', sans-serif;
  }

  .interest-rate {
    background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.875rem;
    font-weight: 600;
    display: inline-block;
    font-family: 'Open Sans', sans-serif;
  }

  .card-body {
    margin-top: 1rem;
  }

  .plan-description {
    color: #4a5568;
    line-height: 1.6;
    margin-bottom: 1rem;
    font-size: 0.95rem;
    font-family: 'Open Sans', sans-serif;
  }

  .warning-text {
    color: #e53e3e;
    font-weight: 500;
    font-size: 0.875rem;
  }

  .plan-features {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .feature {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: #4a5568;
    font-size: 0.875rem;
    font-family: 'Open Sans', sans-serif;

    svg {
      color: #38a169;
      flex-shrink: 0;
    }
  }

  // ── Tab bar ────────────────────────────────────────────────────────────
  .inv-header-tabs {
    border-bottom: 2px solid #e5e7eb;
    margin: 0 1rem 0 1rem;
    div { cursor: pointer; padding-bottom: 10px; }
    h4 { font-size: 14px; font-weight: 600; color: #6B7280; margin: 0; }
    .active {
      border-bottom: 2px solid #EE0E4C;
      margin-bottom: -2px;
      h4 { color: #EE0E4C; }
    }
  }

  // ── My Savings panel ───────────────────────────────────────────────────
  .my-savings-panel {
    padding: 1rem;
  }

  .savings-summary {
    gap: .75rem;
    margin-bottom: 1.25rem;
    .summary-card {
      flex: 1;
      background: #FFF5F7;
      border: 1px solid rgba(238, 14, 76, 0.12);
      border-radius: 12px;
      padding: .85rem .5rem;
      text-align: center;
      .label {
        font-size: 10px;
        color: #6B7280;
        margin-bottom: 4px;
        text-transform: uppercase;
        letter-spacing: .4px;
      }
      .value {
        font-size: 14px;
        font-weight: 700;
        color: #1A2B4A;
        margin: 0;
      }
    }
  }

  .savings-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: .4rem;
  }

  .savings-row-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .plan-name {
      font-weight: 600;
      font-size: 14px;
      margin: 0;
      color: #1A2B4A;
    }
  }

  .savings-row-detail {
    display: flex;
    gap: 1.5rem;
    width: 100%;
    p { font-size: 12px; margin: 0; color: #1A2B4A; }
    .detail-label {
      // eslint-disable-next-line max-len
      color: #6B7280; font-size: 10px; text-transform: uppercase; letter-spacing: .3px;
    }
  }

  .browse-btn {
    background: #EE0E4C;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 8px 20px;
    margin-top: 12px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
  }

  .savings-row-actions {
    width: 100%;
    margin-top: 0.5rem;
  }

  .withdraw-btn {
    background: transparent;
    color: #EE0E4C;
    border: 1px solid #EE0E4C;
    border-radius: 8px;
    padding: 5px 14px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover { background: #EE0E4C; color: white; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
  }

  .pending-badge {
    display: inline-block;
    background: #FFF3CD;
    color: #856404;
    border: 1px solid #FFEEBA;
    border-radius: 8px;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 600;
  }

  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
  }

  .confirm-modal {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    max-width: 360px;
    width: 100%;
    h4 { font-size: 1.1rem; font-weight: 700; color: #1A2B4A; margin-bottom: 0.75rem; }
    p { font-size: 13px; color: #4a5568; margin-bottom: 0.5rem; }
    .warning-text { color: #c53030; font-weight: 500; }
  }

  .modal-actions {
    display: flex;
    gap: 0.75rem;
    margin-top: 1.25rem;
    .cancel-btn {
      flex: 1;
      background: #f3f4f6;
      color: #374151;
      border: none;
      border-radius: 8px;
      padding: 10px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
    }
    .confirm-btn {
      flex: 1;
      background: #EE0E4C;
      color: white;
      border: none;
      border-radius: 8px;
      padding: 10px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      &:disabled { opacity: 0.5; cursor: not-allowed; }
    }
  }

  // ── Responsive design
  @media (max-width: 768px) {
    .content {
      padding: 0.75rem;
      gap: 1rem;
    }

    .savings-card {
      padding: 1.25rem;
    }

    .card-header {
      gap: 0.75rem;
    }

    .plan-icon {
      width: 40px;
      height: 40px;
    }

    .plan-info h3 {
      font-size: 1.125rem;
    }

    .plan-features {
      gap: 0.5rem;
    }
  }
</style>
